import React from 'react';
import { DetailsStep } from './01_detailsStep/DetailsStep';
import { SchedulingCard } from '../Reusable/SchedulingCard';
import { UUID } from '../../../../types/shared/UUID';
import { useGenerateInitialWizardFormData } from './useGenerateInitialWizardFormData';
import { WizardTitle } from './WizardTitle';
import { CreateSigningAppointmentFormData } from './04_confirmationStep/convertToCreateSigningAppointmentRequest';

export interface ICreateAppointmentWizardProps {
  onClose: () => void;
  correctionId?: UUID;
}

export const CreateAppointmentWizard: React.FC<ICreateAppointmentWizardProps> = ({ onClose, correctionId }) => {
  const initialWizardFormData: CreateSigningAppointmentFormData = useGenerateInitialWizardFormData(correctionId);
  return (
    <SchedulingCard title={<WizardTitle isCorrection={!!correctionId} onClose={onClose} />}>
      <DetailsStep
        key={correctionId}
        isCorrection={!!correctionId}
        onClose={onClose}
        wizardFormData={initialWizardFormData}
      />
    </SchedulingCard>
  );
};
